import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Loader from "../Loader";
import Pagination from "react-js-pagination";
import * as constatnts from "../../Constatnts";
import axios from "axios";

class ItemLedger extends Component {
  constructor() {
    super();
    this.state = {
      products: [],
      // loading: true,
      // itemsPerPage: 5, // Number of items to load per click
      // hasMore: true, // Indicates if there are more records to load

      // from: 0,
      size: 10,
      loading: false,
      activePage: 1,
      paginationStatus: "",
    };
    this.onExportClick = this.onExportClick.bind(this);
    this.loadItemLedger = this.loadItemLedger.bind(this);
    // this.handleShowMore = this.handleShowMore.bind(this);
    this.showPaginationStatus = this.showPaginationStatus.bind(this);
  }

  componentDidMount() {
    this.loadItemLedger(
      this.state.activePage,
      this.state.size,
      this.props.location.state.LocationID,
      this.props.location.state.ProductID,
      false
    );
  }

  showPaginationStatus(totalItemsCount, recordFrom) {
    let paginationStatus;
    if (totalItemsCount === 0) {
      paginationStatus = "No records to display";
    } else if (recordFrom + 1 === totalItemsCount) {
      paginationStatus =
        "Showing " + totalItemsCount + " of " + totalItemsCount;
    } else if (recordFrom + this.state.size + 1 > totalItemsCount) {
      paginationStatus =
        "Showing " +
        (recordFrom + 1) +
        " to  " +
        totalItemsCount +
        " of " +
        totalItemsCount;
    } else {
      paginationStatus =
        "Showing " +
        (recordFrom + 1) +
        " to  " +
        (recordFrom + this.state.size) +
        " of " +
        totalItemsCount;
    }
    this.setState({ paginationStatus: paginationStatus });
  }

  // Load item ledger data
  // loadItemLedger(lastVisibleDoc = null) {
  //   this.setState({ loading: true });
  //   this.props
  //     .getItemLedger(
  //       this.props.location.state.ProductID,
  //       this.props.location.state.LocationID,
  //       lastVisibleDoc,
  //       this.state.itemsPerPage
  //     )
  //     .then((result) => {
  //       const newProducts = result.itemLedgers;
  //       const hasMore = newProducts.length === this.state.itemsPerPage; // Check if there are more records

  //       this.setState((prevState) => ({
  //         products: [...prevState.products, ...newProducts], // Append new records
  //         loading: false,
  //         lastVisibleDoc: result.lastVisible, // Update last visible document
  //         hasMore, // Update whether more records are available
  //       }));
  //     })
  //     .catch((error) => {
  //       console.error("Error loading item ledger:", error);
  //       this.setState({ loading: false });
  //     });
  // }

  async loadItemLedger(page, size, locationID, productID, exportData = false) {
    this.setState({ loading: true });

    console.log(
      "this.props.location.state.LocationID",
      this.props.location.state.LocationID
    );
    console.log("locationID, locationID");
    console.log(
      "this.props.location.state.ProductID",
      this.props.location.state.ProductID
    );
    // console.log("productID", productID);
    var allRecords = [];
    var totalItemsCount = 0;

    async function fetchPageData(pageNum) {
      const response = await axios.get(
        "https://posible-audit-trail-ks6s62g5tq-el.a.run.app/inventoryinstock_audit_trail/" +
        locationID +
        "/" +
        productID,
        {
          params: { page: page, limit: size },
          headers: {
            Authorization:
              "21ad4b0831f7133b5ccf837d5cd6e794720238b2e27117a740431f99199f94ea",
          },
        }
      );

      console.log("fetchPageData response", response);
      if (
        response &&
        response.data &&
        response.data.data &&
        Array.isArray(response.data.data) &&
        response.data.data.length > 0
      ) {
        if (
          !totalItemsCount &&
          response.data.pagination &&
          response.data.pagination.total
        ) {
          totalItemsCount = response.data.pagination.total;
        }

        return response.data.data;
      }
      return [];
    }

    if (exportData) {
      // First call to get pagination info
      const firstResponse = await axios.get(
        "https://posible-audit-trail-ks6s62g5tq-el.a.run.app/inventoryinstock_audit_trail/" +
        locationID +
        "/" +
        productID,
        {
          params: { page: page, limit: size },
          headers: {
            Authorization:
              "21ad4b0831f7133b5ccf837d5cd6e794720238b2e27117a740431f99199f94ea",
          },
        }
      );

      if (
        firstResponse &&
        firstResponse.data &&
        firstResponse.data.pagination &&
        firstResponse.data.pagination.total
      ) {
        totalItemsCount = firstResponse.data.pagination.total;
      }

      var totalPages = Math.ceil(totalItemsCount / size);
      var firstPageRecords = [];

      if (
        firstResponse &&
        firstResponse.data &&
        firstResponse.data.data &&
        Array.isArray(firstResponse.data.data)
      ) {
        firstPageRecords = firstResponse.data.data;
      }

      allRecords = allRecords.concat(firstPageRecords);

      // Fetch remaining pages sequentially
      for (var i = 2; i <= totalPages; i++) {
        var pageRecords = await fetchPageData(i);
        allRecords = allRecords.concat(pageRecords);
      }

      // Generate CSV
      var csvData = constatnts.objToCSV(allRecords);
      this.setState({ loading: false });
      var csvBlob = new Blob([csvData], { type: "text/csv" });
      var url = window.URL.createObjectURL(csvBlob);
      var a = document.createElement("a");
      a.setAttribute("hidden", "");
      a.setAttribute("href", url);
      a.setAttribute("download", "inventoryinstock.csv");
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      return;
    }
    // Normal paginated view
    var pageRecords = await fetchPageData(page);
    this.setState({
      products: pageRecords,
      totalItemsCount: totalItemsCount,
      loading: false,
    });
    this.showPaginationStatus(totalItemsCount, (page - 1) * size);
  }

  // Handle "Show More Records" button click
  // handleShowMore() {
  //   this.loadItemLedger(this.state.lastVisibleDoc);
  // }

  // onExportClick() {
  //   let data = [];
  //   this.state.products.map((ledger) => {
  //     let obj = {
  //       Date: new Date(ledger.ActionOn.seconds * 1000)
  //         .toString()
  //         .substring(0, 24),
  //       Location: ledger.Location,
  //       "Store Name": this.props.user.store.StoreName,
  //       SKU: ledger.ProductSKU,
  //       Name: ledger.ProductName,
  //       Category: ledger.Category,
  //       "Sub Category": ledger.SubCategory,
  //       Brand: ledger.Brand,
  //       Barcode: ledger.BarCode,
  //       "Transaction No": ledger.TransactionNo,
  //       "Transaction Type": ledger.TransactionType,
  //       "Transaction Action": ledger.Action,
  //       "Transaction Qty": Number(ledger.TransactionQty).toFixed(2),
  //       "In Stock Qty": Number(ledger.InStockQty).toFixed(2),
  //     };
  //     data.push(obj);
  //   });

  //   const csvData = constants.objToCSV(data);
  //   this.setState({ exportCalled: false });
  //   const csvBlob = new Blob([csvData], { type: "text/csv" });
  //   const url = window.URL.createObjectURL(csvBlob);
  //   const a = document.createElement("a");
  //   a.setAttribute("hidden", "");
  //   a.setAttribute("href", url);
  //   a.setAttribute("download", "Item Ledger.csv");
  //   document.body.appendChild(a);
  //   a.click();
  //   document.body.removeChild(a);
  // }

  onExportClick() {
    this.loadItemLedger(
      this.state.activePage,
      this.state.size,
      this.props.location.state.LocationID,
      this.props.location.state.ProductID,
      true
    );
  }

  render() {
    const { products, loading, hasMore } = this.state;

    return (
      <div className="content-wrapper">
        <section className="content">
          <div className="row">
            <div className="col-md-12">
              <div className="box ">
                <div className="box-header with-border">
                  <div className="row">
                    <div className="col-md-6 col-xs-9">
                      <font style={{ fontSize: "30px" }}>Item Ledger</font>
                    </div>
                    <div className="col-md-6 col-xs-3">
                      <button
                        type="cancel"
                        className="btn btn-default pull-right btn-flat"
                        style={{ marginTop: "5px", marginLeft: "10px" }}
                        onClick={() =>
                          this.props.history.push({
                            pathname: "/home/reports/Instock",
                          })
                        }
                      >
                        <i className="fa fa-arrow-left"></i> Back
                      </button>
                      <button
                        className="btn btn-default btn-flat btn-md pull-right"
                        style={{ marginTop: "5px" }}
                        onClick={this.onExportClick}
                      >
                        {" "}
                        Export{" "}
                        <i className="glyphicon glyphicon-download-alt "></i>
                      </button>
                    </div>
                  </div>
                </div>

                <div className="box-body">
                  {loading && <Loader show={loading} />}
                  {!loading && products.length === 0 && (
                    <div className="text-center">
                      <h4>No data found.</h4>
                    </div>
                  )}
                  {!loading && products.length > 0 && (
                    <div
                      style={{ width: "auto", overflowX: "auto" }}
                      className="scroll2"
                    >
                      <table className="table table-bordered table-striped">
                        <thead>
                          <tr>
                            <th>Date</th>
                            <th>Location</th>
                            <th>SKU</th>
                            <th>Name</th>
                            <th>Category</th>
                            <th>Sub Category</th>
                            <th>Brand</th>
                            <th>Barcode</th>
                            <th>Transaction Type</th>
                            <th>Transaction No</th>
                            <th>Transaction Action</th>
                            <th>Transaction Qty</th>
                            <th>In Stock Qty</th>
                          </tr>
                        </thead>
                        <tbody>
                          {products.map((item, index) => (
                            <tr key={index}>
                             <td>
  {item.ActionOn ? (
    <>
    <div>
  {item.ActionOn.replace("T", " ").split(".")[0]}
</div>
    </>
  ) : (
    ""
  )}
</td>
                              <td>{item.Location}</td>
                              <td>{item.ProductSKU}</td>
                              <td>{item.ProductName}</td>
                              <td>{item.Category}</td>
                              <td>{item.SubCategory}</td>
                              <td>{item.Brand}</td>
                              <td>{item.BarCode}</td>
                              <td>{item.TransactionType}</td>
                              <td>{item.TransactionNo}</td>
                              <td>{item.Action}</td>
                              <td>{Number(item.TransactionQty).toFixed(2)}</td>
                              <td>{Number(item.InStockQty).toFixed(2)}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>

                {this.state.totalItemsCount > 0 && (
                  <div className="row">
                    <div className="col-md-12">
                      <div className="pull-left" style={{ marginTop: "25px" }}>
                        {this.state.paginationStatus}
                      </div>
                      <div className="pull-right">
                        <Pagination
                          activePage={this.state.activePage} //this.state.activePage
                          itemsCountPerPage={this.state.size}
                          totalItemsCount={this.state.totalItemsCount}
                          pageRangeDisplayed={2}
                          onChange={this.handlePageChange}
                        />
                      </div>
                    </div>
                  </div>
                )}
                {/* Show More Records Button */}
                {/* {!loading && hasMore && (
                  <div className="box-footer text-center">
                    <button
                      className="btn btn-primary"
                      onClick={this.handleShowMore}
                    >
                      Show More Records
                    </button>
                  </div>
                )} */}
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default withRouter(ItemLedger);
